import usePureState from '@/hooks/use-pure-state';
import { useSetIntercomIsVisible } from '@/queries/layout.queries';
import { useEffect } from 'react';

type UseModalIntroWizardArgs = {
  isOpen: boolean;
  onClose: () => void;
  onFinish: () => void;
};

export default function useModalIntroWizard(args: UseModalIntroWizardArgs) {
  const mutateIntercomIsVisible = useSetIntercomIsVisible();
  const { state, setPartialState } = usePureState({
    totalStepsNumber: 6,
    activeStep: 0,
  });

  useEffect(() => {
    mutateIntercomIsVisible.mutateAsync(false);
    return () => {
      mutateIntercomIsVisible.mutateAsync(true);
    };
  }, []);

  function handleNextButtonClick() {
    setPartialState({ activeStep: state.activeStep + 1 });

    if (state.activeStep === state.totalStepsNumber - 1) {
      return args.onFinish();
    }
  }

  function handleBackButtonClick() {
    if (state.activeStep === 0) {
      return args.onClose();
    }

    setPartialState({ activeStep: state.activeStep - 1 });
  }

  return {
    activeStep: state.activeStep,
    activeStepIndex: state.activeStep - 1,
    buttonText: state.activeStep === state.totalStepsNumber - 1 ? 'Get Started' : 'Next',
    handleBackButtonClick,
    handleNextButtonClick,
    numberOfSteps: state.totalStepsNumber - 1,
  };
}
